import { match, P } from "ts-pattern";

export type Route =
  | "cameras"
  | "traffic-flow"
  | "vehicles"
  | "reports"
  | "alarm-settings"
  | "audit-log"
  | "clip-compilation"
  | "settings";

export function getActiveRoute(pathname: string): Route | null {
  return match(pathname)
    .with("/", () => "cameras" as const)
    .with(P.string.endsWith("/overview"), () => "cameras" as const)
    .with(P.string.includes("/cameras/"), () => "cameras" as const)
    .with(P.string.startsWith("/settings"), () => "settings" as const)
    .with(P.string.includes("/traffic-flow"), () => "traffic-flow" as const)
    .with(P.string.includes("/vehicles"), () => "vehicles" as const)
    .with(P.string.includes("/reports"), () => "reports" as const)
    .with(P.string.includes("/alarm-settings"), (p) =>
      p.includes("/cameras/") ? ("cameras" as const) : ("alarm-settings" as const),
    )
    .with(P.string.endsWith("/activity"), () => "audit-log" as const)
    .with(P.string.endsWith("/clip-compilation"), () => "clip-compilation" as const)
    .otherwise(() => null);
}
